// Maps (class, gender) → chibi illustration served from /public/assets/classes/.
// Falls back to null when either value is missing, so consumers can render the
// legacy CSS/SVG portrait or full-body layered sprite instead.

const CHIBI = {
  Warrior:  { male: "/assets/classes/warrior_male.png",  female: "/assets/classes/warrior_female.png" },
  Rogue:    { male: "/assets/classes/rogue_male.png",    female: "/assets/classes/rogue_female.png"   },
  Guardian: { male: "/assets/classes/guardian_male.png", female: "/assets/classes/guardian_female.png"},
  Wizard:   { male: "/assets/classes/wizard_male.png",   female: "/assets/classes/wizard_female.png"  },
  Bard:     { male: "/assets/classes/bard_male.png",     female: "/assets/classes/bard_female.png"    },
};

export const GENDERS = ["male", "female"];

export function classChibi(cls, gender, customImage = null) {
  // GM-created classes can provide their own artwork. Prefer it over the
  // built-in class sprite; legacy classes continue using CHIBI below.
  if (customImage) return customImage;
  if (!cls || !gender) return null;
  const g = String(gender).toLowerCase();
  const entry = CHIBI[cls];
  if (!entry) return null;
  return entry[g] || null;
}
